import * as yup from "yup";

export enum LoginInputs {
    EMAIL = "email",
}

export enum VryfyOtpInputs {
    EMAIL = "email",
    OTP = "otp",
}

export interface ILoginInputs {
    email: string,
}
export interface IVerifyOtpInputs {
    email: string,
    otp: number,
}

export enum RegisterInputs {
    EMAIL = "email",
    PHONE = "phone",
    NAME = "name",
}

export const registerDonorSchema = yup.object({
    name: yup.string().required("Name is required"),
    email: yup.string().email("Invalid email").required("Email is required"),
    phone: yup
        .string()
        .matches(/^[0-9]{10}$/, "Please enter a valid 10-digit phone number")
        .optional(),
})

export const loginSchema = yup.object({
    [LoginInputs.EMAIL]: yup.string().email("Invalid email").required("Email is required"),

});

export const verifyOtpSchema = yup.object({
    [VryfyOtpInputs.EMAIL]: yup.string().email("Invalid email").required("Email is required"),
    [VryfyOtpInputs.OTP]: yup.number().required("otp is required"),

});

export interface IRegisterDonorInputs {
    name: string,
    email: string,
    phone?: string | number;
}

export interface IVerifyOtpInputs {
    email: string,
    otp: number;
}